import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { UcPackage } from '../../types';
import UcPackageCard from './UcPackageCard';
import { colors } from '../../theme/themeConfig';

interface UcPackagesListProps {
  packages: UcPackage[];
  onBuyPackage: (pkg: UcPackage) => void;
  onSelectCodes?: (pkg: UcPackage, count: number) => void;
  loading?: boolean;
}

const UcPackagesList: React.FC<UcPackagesListProps> = ({ 
  packages, 
  onBuyPackage, 
  onSelectCodes,
  loading = false 
}) => {
  const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery('(max-width: 375px)'); // Using single breakpoint as per user preference

  if (loading) {
    return (
      <Typography 
        align="center" 
        sx={{ 
          padding: theme.spacing(3),
          color: colors.text.secondary
        }}
      >
        Загрузка пакетов UC...
      </Typography>
    );
  }

  if (!packages || packages.length === 0) {
    return (
      <Typography 
        align="center" 
        sx={{ 
          padding: theme.spacing(3),
          color: colors.text.secondary
        }}
      >
        Нет доступных пакетов UC
      </Typography>
    );
  }

  return (
    <Box 
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: isMobile ? '8px' : '16px',
        width: '100%',
        marginBottom: theme.spacing(3)
      }}
    >
      {packages.map((pkg) => (
        <UcPackageCard 
          key={pkg.id} 
          package={pkg} 
          onBuy={onBuyPackage}
          onSelectCodes={onSelectCodes}
        />
      ))}
    </Box>
  );
};

export default UcPackagesList;
